import NextLink from 'next/link';
import { forwardRef } from 'react';
import { shouldTriggerStartEvent } from './should-trigger-start-event';
import { usePageLoaderStore } from '@/stores/pageLoaderStore';

export const Link = forwardRef<HTMLAnchorElement, React.ComponentProps<'a'>>(
  function Link({ href, onClick, ...rest }, ref) {
    const useLink = href && href.startsWith('/');
    if (!useLink) return <a href={href} onClick={onClick} {...rest} />;

    const setter = usePageLoaderStore.use.setter();

    return (
      <NextLink
        href={href}
        onClick={event => {
          if (shouldTriggerStartEvent(href, event)) setter({ show: true });
          if (onClick) onClick(event);
        }}
        {...rest}
        ref={ref}
      />
    );
  },
);
